import React from 'react';
// Scholarships & Awards Notification
const FifteenStepTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    deadline_date,
    scholarship_link,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>{client_name ? `Hi ${client_name}` : `Hi [Recipient's Name],`}</p>
      <p>
        We’re excited to announce that{' '}
        {conference_short_name ? conference_short_name : `[Conf Short Name]`} is
        offering <strong>scholarship opportunities</strong> for our upcoming
        event! 🎓
      </p>

      <p>
        You can avail:
        <br />✅ <strong>
          Partial In-Person Scholarship (40% Fee Waiver)
        </strong>{' '}
        – For scholars demonstrating excellence.
        <br />✅ <strong>Partial Virtual Scholarship (20% Fee Waiver)</strong> –
        Supporting outstanding remote participants.Network with leading experts
        and professionals from around the world
        <br />✅ <strong>Full Scholarship (100% Fee Waiver)</strong> – Awarded
        to one distinguished scholar for exceptional contributions.
      </p>
      <p>
        Don’t miss this opportunity to gain recognition, network with industry
        leaders, and showcase your work.
      </p>

      <p>
        {deadline_date ? (
          <>
            <strong>
              👉 Apply for the scholarship by{' '}
              {deadline_date ? deadline_date : `[Deadline Date]`} here:{' '}
            </strong>
            {scholarship_link ? (
              <a
                href={scholarship_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Click Here
              </a>
            ) : (
              `[Scholarship Link]`
            )}
          </>
        ) : (
          <strong>
            👉 Apply for the scholarship by [Deadline Date] here: [Scholarship
            Link]
          </strong>
        )}
      </p>

      <p>
        <strong>Awards & Recognition:</strong>
        <br />
        🏆 <strong>Best Paper Award</strong> – Recognizing groundbreaking
        research.
        <br />
        🎤 <strong>Best Paper Presentation Award</strong> – Honoring impactful
        research delivery.
        <br />
        🏛 <strong>Research Excellence Award (University)</strong> – Celebrating
        institutional research leadership.
        <br />
        👨‍🎓 <strong>Research Excellence Award (Student)</strong> – Encouraging
        young research talent.
        <br />
        👩‍🏫 <strong>Research Excellence Award (Faculty)</strong> – Acknowledging
        significant academic contributions.
      </p>
      <p>
        This is your chance to shine and make a lasting impact in your field.
        Apply today and secure your spot at this prestigious event!
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default FifteenStepTemplate;
